import React from "react";

export interface IconProps extends React.SVGProps<SVGElement> {
  svg: React.FC<React.SVGProps<SVGElement> & { title?: string }>;
  title?: string;
}

const Icon: React.FC<IconProps> = ({ svg: SvgIcon, ...props }) => (
  <SvgIcon {...(props.title && { "aria-label": props.title })} {...props} />
);

Icon.defaultProps = {
  "aria-hidden": true,
  focusable: false
};

export { Icon };
